<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {LeagueKind} from "@/modules/redactor/models/leaderboard/LeagueKind";

export default {
  name: "r-league-kind",
  props: {
    model: VueTypes.instanceOf(LeagueKind),
    label: VueTypes.string.def("League Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return LeagueKind.getValues();
    }
  }
}
</script>
